import { useTranslation } from 'react-i18next';
import { InputLabel } from '@/components/ui/InputLabel';
import { Label } from '@/components/ui/label';
import type { Hms } from '@/lib/evergreenInteractionSchedule';

type HmsInputsProps = {
  label: string;
  value: Hms;
  onChange?: (value: Hms) => void;
  disabled?: boolean;
};

const FIELDS = [
  { key: 'h', labelKey: 'time.hourLabel', unit: 'hr' },
  { key: 'm', labelKey: 'time.minuteLabel', unit: 'min' },
  { key: 's', labelKey: 'time.secondLabel', unit: 'sec' },
] as const;

export default function HmsInputs({ label, value, onChange, disabled }: HmsInputsProps) {
  const { t } = useTranslation('createWebinar');
  return (
    <div className="w-full md:w-1/2 flex flex-col gap-4">
      <Label>{label}</Label>
      <div className="flex items-center justify-between w-full gap-2">
        {FIELDS.map((field) => (
          <div key={field.key} className="relative w-1/3">
            <InputLabel
              label={t(field.labelKey)}
              inputMode="numeric"
              min={0}
              maxLength={2}
              value={value[field.key]}
              disabled={disabled || !onChange}
              onChange={(event) =>
                onChange?.({ ...value, [field.key]: event.target.value.replace(/\D/g, '') })
              }
            />
            <div className="absolute top-3 right-2 text-base translate-y-1/2 text-tertiary">
              {field.unit}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
